import { render, staticRenderFns } from "./phone-number.vue?vue&type=template&id=8b739a7a&scoped=true"
import script from "./phone-number.vue?vue&type=script&lang=js"
export * from "./phone-number.vue?vue&type=script&lang=js"
import style0 from "./phone-number.vue?vue&type=style&index=0&id=8b739a7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b739a7a",
  null
  
)

export default component.exports